import { render, staticRenderFns } from "./Inforg.vue?vue&type=template&id=690f01a2&scoped=true"
import script from "./Inforg.vue?vue&type=script&lang=js"
export * from "./Inforg.vue?vue&type=script&lang=js"
import style0 from "./Inforg.vue?vue&type=style&index=0&id=690f01a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f01a2",
  null
  
)

export default component.exports